import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            关于久久草，您想知道的
          </h2>
          <p className="max-w-lg mx-auto text-sm md:text-base text-foreground-600 leading-relaxed">
            整理了大家最关心的问题，帮您快速了解久久草
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <div
                    className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                      isOpen
                        ? 'bg-accent-500 text-background-50 rotate-180'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-400 ${
                    isOpen ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}